module.exports = __webpack_public_path__ + "img/RS-PPE-ICONS-QUESTION.52617d06.svg";